import React, { useEffect, useState } from "react";
import { getRequest } from "../../globalhelper/helper";
import CloseIcon from "@mui/icons-material/Close";
import GetAppIcon from "@material-ui/icons/GetApp";
import { CSVLink } from "react-csv";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import PropTypes from "prop-types";
import { Accordion, AccordionDetails, AccordionSummary, Alert, AlertTitle, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography, useTheme } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { useDispatch } from "react-redux";
import { hideLoader, showLoader } from "../../redux/Common/commonActions";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
const VendorListReport = () => {
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [companyDetails, setCompanyDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [logData, setLogData] = useState([]);
  const [message, setMessgae] = useState(null);
  const [logHeaders, setLogHeaders] = useState([]);
  const [vendorname, setVendorname] = useState("");
  const [vendorid, setVendorid] = useState("");
  const [status, setStatus] = useState("");
  const [vendorNames, setVendornames] = useState([]);
  const [vendorIDs, setVendorIDs] = useState([]);
  const [ApprovalStatus, setApprovalStatus] = useState([]);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    company: "",
    fromDate: "",
    toDate: ""
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Avoid a layout jump when reaching the last page with empty filteredData.
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length) : 0;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data;
      const orgname = responseData.map(item => item?.orgname);
      setCompanyDetails(responseData);
      setCompanyName(orgname);
      if (orgname.length === 1) {
        setFormData(prev => {
          return {
            ...prev,
            company: orgname[0]
          };
        });
      }
    });
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFormData(prev => {
      return {
        ...prev,
        fromDate: firstDay,
        toDate: lastDay
      };
    });
  }, []);
  const handleChange = (name, value) => {
    setFormData(prev => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const handleReset = () => {
    setFormData({
      fromDate: "",
      toDate: "",
      company: ""
    });
    setTableData([]);
    setFilteredData([]);
    setVendornames([]);
    setVendorIDs([]);
    setApprovalStatus([]);
    setVendorname("");
    setVendorid("");
    setStatus("");
  };
  const handleSubmit = () => {
    const {
      fromDate,
      toDate,
      company
    } = formData;
    dispatch(showLoader());
    if (fromDate && toDate && company) {
      const id = companyDetails.filter(item => item?.orgname === company);
      const companyid = id.map(item => item?.orgid);
      console.log(companyid);
      getRequest(`api/edureka/getVendorListForReport?fromDate=${fromDate}&toDate=${toDate}&company=${companyid[0]}`).then(response => {
        const responseData = response.res.data;
        console.log(responseData);
        if (responseData.length > 0) {
          setTableData(responseData);
          setFilteredData(responseData);
          setApprovalStatus(Array.from(new Set(responseData.map(item => item.approvalstatustext))).sort());
          setVendornames(Array.from(new Set(responseData.map(item => item.vendorname))).sort());
          setVendorIDs(Array.from(new Set(responseData.map(item => item.vendorid))).sort());
        } else {
          setMessgae(<Box sx={{
            margin: "auto"
          }}>
                <Alert severity="warning">
                  <AlertTitle>No Data Found</AlertTitle>
                  There is no data to display at the moment.
                </Alert>
              </Box>);
          setTableData([]);
          setFilteredData([]);
          setApprovalStatus([]);
          setVendornames([]);
          setVendorIDs([]);
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {
        dispatch(hideLoader());
      });
    }
  };
  const handleCheckLogs = async (vendorid, vendorname) => {
    try {
      dispatch(showLoader());
      // Fetch logs and open modal
      const {
        company
      } = formData;
      const id = companyDetails.filter(item => item?.orgname === company);
      const companyid = id.map(item => item?.orgid);
      let response = await getRequest(`api/edureka/checkVendorLogs?vendorid=${vendorid}&vendorname=${vendorname}&orgid=${companyid}`);
      const logs = response.res.data; // Assuming API returns an array of logs
      console.log(logs);
      if (logs.length > 0) {
        // Set headers dynamically based on keys from the first log item
        const headers = Object.keys(logs[0]);
        setLogHeaders(headers);
        setLogData(logs);
        setShowModal(true);
      } else {}
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(hideLoader());
    }
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setLogData([]);
  };
  const convertTimestampToDate = timestamp => {
    const date = new Date(timestamp);
    return date.toLocaleString(); // Convert to readable date and time
  };
  useEffect(() => {
    if (vendorname === "" && vendorid === "" && status === "" || !vendorname && !vendorid && !status) {
      setFilteredData(tableData);
    } else {
      handleFilterChange(vendorname, vendorid, status);
    }
  }, [vendorname, vendorid, status]);
  const handleFilterChange = (vendorname, vendorid, status) => {
    setPage(0);
    let filteredData = tableData.filter(data => data.vendorname === vendorname || data.approvalstatustext === status || data.vendorid === vendorid);
    setFilteredData(filteredData);
  };
  return <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Search Report</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xl={3}>
              <Autocomplete options={companyName || []} value={formData.company} onChange={(e, newValue) => handleChange("company", newValue)} fullWidth renderInput={params => <TextField {...params} label="Organization Name" variant="outlined" size="small" />} />
            </Grid>

            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="ForPrdFrom" value={formData.fromDate} views={["day", "month", "year"]} onChange={newValue => {
                handleChange("fromDate", newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="ForPrdTo" value={formData.toDate} views={["day", "month", "year"]} onChange={newValue => {
                handleChange("toDate", newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
              </LocalizationProvider>
            </Grid>

            <Grid item xl={1}>
              <Button variant="contained" color="primary" onClick={handleSubmit}>
                Submit
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button variant="contained" color="error" onClick={handleReset} style={{
              marginLeft: "10px"
            }}>
                Reset
              </Button>
            </Grid>
            {tableData.length > 0 && <>
                <Grid item xl={3}>
                  <Autocomplete options={vendorNames || []} value={vendorname || null} onChange={(e, newValue) => {
                setVendorname(newValue);
                setStatus("");
                setVendorid("");
              }} fullWidth renderInput={params => <TextField {...params} label="Filter Vendor Name" variant="outlined" size="small" />} />
                </Grid>
                <Grid item xl={3}>
                  <Autocomplete options={vendorIDs || []} value={vendorid || null} onChange={(e, newValue) => {
                setVendorname("");
                setStatus("");
                setVendorid(newValue);
              }} fullWidth renderInput={params => <TextField {...params} label="Filter Vendor ID" variant="outlined" size="small" />} />
                </Grid>
                <Grid item xl={3}>
                  <Autocomplete options={ApprovalStatus || []} value={status || null} onChange={(e, newValue) => {
                setVendorname("");
                setStatus(newValue);
                setVendorid("");
              }} fullWidth renderInput={params => <TextField {...params} label="Filter Approval Status" variant="outlined" size="small" />} />
                </Grid>
              </>}
          </Grid>
        </AccordionDetails>
      </Accordion>

      {tableData.length ? <>
          <Box align="right" sx={{
        m: 2,
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 2
      }}>
            <Pagination count={Math.ceil(filteredData.length / rowsPerPage)} page={page + 1} onChange={(event, newPage) => {
          handleChangePage(event, newPage - 1);
        }} variant="outlined" shape="rounded" showFirstButton showLastButton />
            &nbsp;
            <CSVLink size="sm" filename={`VendorListReport_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`} data={tableData}>
              <Button variant="contained" color="success">
                <GetAppIcon />
              </Button>
            </CSVLink>
          </Box>
          <TableContainer component={Paper}>
            <Table sx={{
          minWidth: 650
        }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Approval Status
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Created DateTime
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Modified DateTime
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>Vendor ID</TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Member Type
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>MSME</TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Member Group
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Vendor Name
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>Currency</TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    GST Treatment
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Tax Preference
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Vendor Tax Classification
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>PAN</TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Payment Mode
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Account Holder Name
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Account Number
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>Bank Name</TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>Bank Type</TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>
                    Branch Name
                  </TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>IFSC Code</TableCell>
                  <TableCell sx={{
                whiteSpace: "nowrap"
              }}>MICR Code</TableCell>
                  <TableCell style={{
                whiteSpace: "nowrap",
                textAlign: "center",
                position: "sticky",
                right: 0,
                zIndex: 2,
                padding: 0,
                background: "#fff"
              }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 && (rowsPerPage > 0 ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : filteredData).map((item, index) => {
              return <tr key={index}>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.approvalstatustext}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.createddatetime}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.modifieddatetime}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.vendorid}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.membertype}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.msme}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.membergroup}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.vendorname}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.currency}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.gsttreatment}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.taxpreference}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.vendortaxclassification}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.pan}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.paymentmode}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.accountholdername}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.accountnumber}
                        </TableCell>
                        <TableCell>{item?.bankname}</TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.banktype}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.branchname}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.ifsccode}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap"
                }}>
                          {item?.micrcode}
                        </TableCell>
                        <TableCell sx={{
                  whiteSpace: "nowrap",
                  pl: 1,
                  pt: 0,
                  pb: 0,
                  position: "sticky",
                  right: 0,
                  backgroundColor: "#fff",
                  zIndex: 2
                }}>
                          <Button size='small' variant='contained' color='primary' onClick={() => handleCheckLogs(item?.vendorid, item?.vendorname)}>
                            Check Logs
                          </Button>
                        </TableCell>
                      </tr>;
            }) || <TableRow>
                      <TableCell colSpan={Object.keys(tableData[0]).length}>
                        <Box sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%"
                }}>
                          <Alert severity="error" variant="outlined">
                            No matching records found. Please adjust your search
                            criteria.
                          </Alert>
                        </Box>
                      </TableCell>
                    </TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
        </> : message}

      {/* Modal for displaying logs */}
      <Dialog open={showModal} onClose={handleCloseModal} fullWidth maxWidth="xl" sx={{
      "& .MuiDialog-paper": {
        marginLeft: "90px"
      }
    }}>
        <DialogTitle sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pr: 2
      }}>
          Vendor Logs
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{
        maxHeight: "500px",
        overflowY: "auto"
      }}>
          {logData.length ? <TableContainer component={Paper}>
              <Table sx={{
            minWidth: 650
          }} aria-label="vendor log table">
              <TableHead>
                <TableRow>
                  {(logData && logData.length > 0 ? Object.keys(logData[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                  textAlign: 'left'
                }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {(logData || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
                  let displayVal = val;
                  if (typeof val === 'number' && !Number.isInteger(val)) {
                    displayVal = val.toFixed(2);
                  } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                    displayVal = parseFloat(val).toFixed(2);
                  } else if (typeof val === 'boolean') {
                    displayVal = val ? 'Yes' : 'No';
                  } else if (val === null || val === undefined) {
                    displayVal = '';
                  } else if (typeof val === 'object') {
                    displayVal = JSON.stringify(val);
                  }
                  return <TableCell key={valIndex} sx={{
                    textAlign: 'left'
                  }}>
                          {String(displayVal)}
                        </TableCell>;
                })}
                  </TableRow>)}
              </TableBody>
            </Table>
            </TableContainer> : <p>No logs available</p>}
        </DialogContent>

        <DialogActions>
          <CSVLink data={logData} filename="VendorList_Report.csv" style={{
          textDecoration: "none"
        }}>
            <Button variant="outlined">Download</Button>
          </CSVLink>
          <Button variant="contained" color="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>;
};
export default VendorListReport;